import { computed } from "vue";

const FEATURE_FLAG_VACATION_UPLOADS = "vacation-uploads";
const FEATURE_FLAG_STATS_DETAILED = "stats-detailed";
const FEATURE_FLAG_CREATE_NEW_TEAM = "team-create";
const FEATURE_FLAG_EDIT_TEAM = "team-edit";

function isEnvFlagEnabled(name: string): boolean {
  return import.meta.env[name as keyof ImportMetaEnv] === "true";
}

export default function useFeatureFlags() {
  const isVacationUploadsEnabled = computed(() =>
    isEnvFlagEnabled("VITE_FEATURE_FLAG_VACATION_UPLOADS"),
  );

  const isDetailedStatsEnabled = computed(() =>
    isEnvFlagEnabled("VITE_FEATURE_FLAG_STATS_DETAILED"),
  );

  const isCreateNewTeamEnabled = computed(() =>
    isEnvFlagEnabled("VITE_FEATURE_FLAG_CREATE_NEW_TEAM"),
  );

  const isEditTeamEnabled = computed(() =>
    isEnvFlagEnabled("VITE_FEATURE_FLAG_EDIT_TEAM"),
  );

  const featureFlags = computed(() => ({
    [FEATURE_FLAG_VACATION_UPLOADS]: isVacationUploadsEnabled.value,
    [FEATURE_FLAG_STATS_DETAILED]: isDetailedStatsEnabled.value,
    [FEATURE_FLAG_CREATE_NEW_TEAM]: isCreateNewTeamEnabled.value,
    [FEATURE_FLAG_EDIT_TEAM]: isEditTeamEnabled.value,
  }));

  return {
    featureFlags,
    isVacationUploadsEnabled,
    isDetailedStatsEnabled,
    isCreateNewTeamEnabled,
    isEditTeamEnabled,
  };
}
